const STORAGE_PREFIX = 'pep.profilePicture.operation.';

/**
 * Persist only enough identity to resume: actor, target, operation id, idempotency key, expected image id.
 * Never persist original bytes or upload URLs.
 */
export function resumeStorageKey(actorId, targetUserId) {
  return `${STORAGE_PREFIX}${actorId}:${targetUserId}`;
}

export function loadResumeState(storage, actorId, targetUserId) {
  try {
    const raw = storage.getItem(resumeStorageKey(actorId, targetUserId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.operationId || !parsed.idempotencyKey) return null;
    return parsed;
  } catch (err) {
    return null;
  }
}

export function saveResumeState(storage, actorId, targetUserId, state) {
  storage.setItem(
    resumeStorageKey(actorId, targetUserId),
    JSON.stringify({
      operationId: state.operationId,
      idempotencyKey: state.idempotencyKey,
      expectedImageId: state.expectedImageId === undefined ? null : state.expectedImageId,
      action: state.action,
    }),
  );
}

export function clearResumeState(storage, actorId, targetUserId) {
  storage.removeItem(resumeStorageKey(actorId, targetUserId));
}
